module.exports = __webpack_public_path__ + "static/media/logo.ba0c8778.svg";